// extracted by mini-css-extract-plugin
module.exports = {"PostTeaser__root":"vEnP","PostTeaser__content":"_01w6","PostTeaser__byline":"JDfc","PostTeaser__audioText_inner":"S0A0"};